<template>
  <div>
    <template v-if="selectedMcsId === 15">
      <app-datepicker
        label="Месяц"
        v-model="month"
        minimum-view="month"
        format="MMMM yyyy"
        class="w-full mx-auto"
        style="max-width:200px"
      />
    </template>
    <template v-else>
      <elsa-v-select
        class="w-full mx-auto"
        style="max-width:200px"
        :options="deviceTypes"
        v-model="devicesValuesType"
        label="name"
        :reduce="item => item.id"
        :appendToBody="true"
        html-label="Тип приборов"
      />
    </template>
    <div class="vx-col flex justify-center flex-wrap">
      <div class="w-full flex justify-center">
        <vs-upload
          action="#"
          :limit="1"
          :show-upload-button="false"
          text="Загрузить файл"
          @change="changeDevicesValuesFile"
          @on-delete="deleteDevicesValuesFile"
          class="w-auto mx-auto"
          ref="uploader"
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        />
      </div>
      <vs-button type="border" color="success" @click="importDevicesValues">Загрузить</vs-button>
      <div class="w-full text-center mt-4">
        <p>Формат файла - xls, xlsx, csv.</p>
        <p>Скачать пример можно <a href="#">здесь</a></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:     "UploadDevicesValues",
  data() {
    return {
      devicesValuesFile:       null,
      devicesValuesType:       null,
      deviceTypes:             [],
      devicesValuesTypes:      [],
      devicesValuesTypesError: false,
      month:                   Date.now(),
    };
  },
  computed: {
    selectedHouse() {
      return this.$store.getters['appUser/selectedHouse'];
    },
    selectedMcsId() {
      return this.selectedHouse.management_companies_id;
    },
  },
  methods:  {
    changeDevicesValuesFile( event, file ) {
      this.devicesValuesFile = file[file.length - 1];
    },
    deleteDevicesValuesFile() {
      this.devicesValuesFile = null;
    },
    async importDevicesValues() {
      if (!this.devicesValuesFile) return;
      let body = new FormData();
      body.append('values_file', this.devicesValuesFile);
      body.append('buildings_id', this.$store.getters['appUser/selectedHouse'].id);
      body.append('users_id', this.$store.getters['appUser/id']);

      if (this.selectedMcsId === 15) {
        body.append('device_types', '4');
        body.append('month', this.$options.filters.formatDate(this.month));
        // if (!this.devicesValuesTypes.length) {
        //   this.devicesValuesTypesError = true;
        //   return false;
        // } else {
        //   body.append('device_types', this.devicesValuesTypes);
        //   return false;
        // }
      } else {
        body.append('device_type', this.devicesValuesType);
      }

      this.$vs.loading({ type: 'default' });
      try {
        let { data } = await this.$http.post('import/device_values', body);
        if (data === 'error' || data.message === 'error') {
          this.$vs.notify({
            color: 'danger',
            title: 'Неверный формат даты',
            text:  `Требуемый формат YYYY-MM-DD. Вы ввели "${data.date || ''}"`,
          });
        } else if (data === 'denied') {
          this.$vs.notify({
            color: 'danger',
            title: 'Ошибка загрузки',
            text:  'На данный месяц уже показаны квитанции',
          });
        } else {
          this.$emit('uploaded', { info: data });
          this.$vs.notify({ color: 'success', title: 'Импорт завершен', text: 'Файл импортирован' });
          this.resetFile();
        }
      } catch (e) {
        if (e.response) {
          if (e.response.status === 403) {
            this.$vs.notify({ color: 'danger', title: 'Ошибка доступа', text: 'Недостаточно прав' });
          } else {
            this.$vs.notify({ color: 'danger', title: 'Ошибка сервера', text: 'Повторите позже' });
          }
        } else {
          this.$vs.notify({ color: 'danger', title: 'Произошла ошибка', text: 'Неизвестная ошибка' });
        }
      } finally {
        this.$vs.loading.close();
      }
    },
    getDevicesTypes() {
      return new Promise(async resolve => {
        let { data } = await this.$http.get('devices_type');
        this.deviceTypes = data;
        this.devicesValuesType = data[0].id;
        this.devicesValuesTypes = [];
        this.devicesValuesTypesError = false;
        resolve(data);
      });
    },
    resetFile() {
      this.devicesValuesFile = null;
      this.$refs.uploader.srcs = [];
      this.$refs.uploader.itemRemove = [];
      this.$refs.uploader.filesx = [];
    },
  },
  async mounted() {
    await this.getDevicesTypes();
  },
  watch:    {
    devicesValuesType() {
      this.resetFile();
    },
  },
};
</script>
